import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Button as AButton } from '@chatterbug/aaron'
import { Button } from '@chatterbug/theme'

import CoachMark from 'src/ui/CoachMark/CoachMark'
import { t } from 'src/lib/i18n-react'

const SPOTLIGHT_SX = {
  // use `px`
  borderRadius: '30px',
}

const CONTAINER_SX = {
  display: 'flex',
  flex: 1,
}

const ButtonGroup = ({ primaryAction, secondaryAction, coachMarkProps }) => {
  const primaryButton = (
    <AButton
      type="primaryAdvanced"
      href={primaryAction.linkUrl}
      onClick={primaryAction.onClick}
      css={{ flex: 1 }}
      disabled={primaryAction.disabled}
      disableWith={t('Loading...')}
      data-testid="primary-button"
    >
      {primaryAction.label}
    </AButton>
  )

  return (
    <Flex
      flexWrap="wrap"
      alignItems="center"
      flexDirection={{ _: 'column', tablet: 'row' }}
      width={{ _: '100%', tablet: 'auto' }}
    >
      <Flex
        width={{ _: '100%', tablet: 'auto' }}
        mb="1x"
        mr={{ _: 0, tablet: '2x' }}
      >
        {coachMarkProps ? (
          <CoachMark
            spotlightSx={SPOTLIGHT_SX}
            sx={CONTAINER_SX}
            {...coachMarkProps}
          >
            {primaryButton}
          </CoachMark>
        ) : (
          primaryButton
        )}
      </Flex>
      {secondaryAction?.label && (
        <Box mb="1x">
          <Button
            kind="tertiary"
            as="link"
            href={secondaryAction?.linkUrl}
            onClick={secondaryAction?.onClick}
            style={{ flex: 1 }}
            data-testid="secondary-button"
          >
            {secondaryAction.label}
          </Button>
        </Box>
      )}
    </Flex>
  )
}

ButtonGroup.propTypes = {
  primaryAction: PropTypes.shape({
    label: PropTypes.string.isRequired,
    linkUrl: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }).isRequired,
  secondaryAction: PropTypes.shape({
    label: PropTypes.string.isRequired,
    linkUrl: PropTypes.string,
    onClick: PropTypes.func,
  }),
  coachMarkProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    align: PropTypes.string.isRequired,
  }),
}

export default ButtonGroup
